"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRangeInput = exports.numFormat = void 0;
const range_slider_price_1 = require("@pulse-web-ui/range-slider-price");
const switch_1 = require("@pulse-web-ui/switch");
const tooltip_1 = require("@pulse-web-ui/tooltip");
const react_1 = __importStar(require("react"));
const range_input_styles_1 = require("./range-input.styles");
const range_input_types_1 = require("./range-input.types");
const use_caret_1 = require("./use-caret");
const utils_1 = require("./utils");
const numFormat = (number) => new Intl.NumberFormat('ru-RU').format(number);
exports.numFormat = numFormat;
const BaseRangeInput = (_a) => {
    var { label, readOnly, disabled, onChange, onBlur, parser, formatter = (val) => val, autoFocus = false, value: v, controlRef, warning, min, max, step, error, hasStepsLabel, helperErrorText, hasTooltip, tooltipLabel, tooltipStyles, tooltipText, trigger = tooltip_1.TriggerDirection.HOVER, direction, arrow, currency = range_input_types_1.Currency.RUB, hasStepsMarkers, iconPosition = range_input_types_1.IconPosition.LEFT, icon, isPriceFormatted, testId = 'rangeInput', tooltipBgColor, labelStyles, hasSwitch, caption, description, onChangeVisibility, extraContent, isRangeSliderVisible = true, inputLabel, isSwitchOff, isSkipMinLimit } = _a, props = __rest(_a, ["label", "readOnly", "disabled", "onChange", "onBlur", "parser", "formatter", "autoFocus", "value", "controlRef", "warning", "min", "max", "step", "error", "hasStepsLabel", "helperErrorText", "hasTooltip", "tooltipLabel", "tooltipStyles", "tooltipText", "trigger", "direction", "arrow", "currency", "hasStepsMarkers", "iconPosition", "icon", "isPriceFormatted", "testId", "tooltipBgColor", "labelStyles", "hasSwitch", "caption", "description", "onChangeVisibility", "extraContent", "isRangeSliderVisible", "inputLabel", "isSwitchOff", "isSkipMinLimit"]);
    const inputRef = (0, react_1.useRef)(null);
    const propValue = v !== undefined ? String(v) : '';
    const initialValue = (0, react_1.useMemo)(() => formatter(propValue ? propValue : ''), [propValue, formatter]);
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const { setCaretPosition } = (0, use_caret_1.useCaret)(inputRef, value, formatter);
    const onChangeIsVisible = (0, react_1.useCallback)((e) => {
        if (isSwitchOff)
            return;
        setIsVisible(e.target.checked);
        onChangeVisibility === null || onChangeVisibility === void 0 ? void 0 : onChangeVisibility(e.target.checked);
    }, [isSwitchOff, onChangeVisibility]);
    (0, react_1.useEffect)(() => {
        if (isSwitchOff) {
            setIsVisible(false);
        }
    }, [isSwitchOff]);
    (0, react_1.useEffect)(() => {
        setValue((prev) => {
            if (parser(propValue || '') !== parser(prev)) {
                setCaretPosition(propValue || '');
                return propValue || '';
            }
            return prev;
        });
    }, [propValue, parser, setCaretPosition]);
    const handleChange = (newValue) => {
        if (max < parser(newValue)) {
            return;
        }
        setValue(newValue);
        setCaretPosition(newValue);
        onChange && onChange(parser(newValue));
    };
    const handleBlur = (0, react_1.useCallback)((e) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        const newValue = parser(e.target.value);
        if (max < newValue) {
            setValue(String(max));
            setCaretPosition(String(max));
            onChange && onChange(max);
        }
        if ((min > newValue || Number.isNaN(newValue)) && !isSkipMinLimit) {
            setValue(String(min));
            setCaretPosition(String(min));
            onChange && onChange(min);
            return;
        }
        if (parser(value) === 0) {
            setValue('0');
            setCaretPosition('0');
            onChange && onChange(0);
            return;
        }
        setValue(String(newValue));
        setCaretPosition(String(newValue));
        onChange && onChange(parser(String(newValue)));
    }, [max, setValue, onChange, onBlur, setCaretPosition, value]);
    const formattedValue = (0, react_1.useMemo)(() => formatter(value), [formatter, value]);
    const priceFormatter = (0, react_1.useCallback)((value) => {
        if (isPriceFormatted && value) {
            return `${(0, exports.numFormat)(Number(value))} ${range_input_types_1.CurrencyLabel[currency]}`;
        }
        return value ? `${value} ${range_input_types_1.CurrencyLabel[currency]}` : value;
    }, [currency, isPriceFormatted]);
    const handleInputOnFocus = (e) => {
        var _a;
        if (((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.readOnly) && !readOnly) {
            inputRef.current.readOnly = false;
        }
        window.setTimeout(function () {
            const end = e.target.value.length;
            e.target.setSelectionRange(end, end - 2);
        }, 0);
    };
    const handleRangeSliderChange = (0, react_1.useCallback)((val) => {
        onChange(val);
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.readOnly = true;
        }
    }, [inputRef, onChange]);
    return (react_1.default.createElement("div", null,
        label && (react_1.default.createElement(range_input_styles_1.StyledHeader, null,
            react_1.default.createElement(range_input_styles_1.StyledLabelBox, null,
                react_1.default.createElement(range_input_styles_1.StyledLabel, { styles: labelStyles }, label),
                hasTooltip && (react_1.default.createElement(tooltip_1.Tooltip, { tooltipLabel: tooltipLabel, tooltipText: tooltipText, trigger: trigger, direction: direction, arrow: arrow, styles: tooltipStyles !== null && tooltipStyles !== void 0 ? tooltipStyles : {}, tooltipBgColor: tooltipBgColor }))),
            hasSwitch && (react_1.default.createElement(switch_1.Switch, { disabled: disabled, value: isVisible, width: 46, onChange: onChangeIsVisible })))),
        isVisible && (react_1.default.createElement(react_1.default.Fragment, null,
            caption,
            react_1.default.createElement(range_input_styles_1.StyledWrapper, { label: label },
                react_1.default.createElement(range_input_styles_1.StyledInput, { value: formattedValue, readOnly: readOnly, disabled: disabled, error: error, warning: warning, onChange: handleChange, onBlur: handleBlur, ref: (0, utils_1.mergeRefs)(inputRef, controlRef), autoCorrect: "off", autoFocus: autoFocus, onFocus: handleInputOnFocus, inputMode: "numeric", type: "numeric", label: inputLabel, "data-testid": `${testId}.input` }),
                icon && (react_1.default.createElement(range_input_styles_1.StyledIconBox, { iconPosition: iconPosition }, icon)),
                isRangeSliderVisible && (react_1.default.createElement(range_input_styles_1.StyledRangePriceBox, null,
                    react_1.default.createElement(range_slider_price_1.RangeSliderPrice, Object.assign({ isPriceFormatted: isPriceFormatted, disabled: disabled, error: error, onChange: handleRangeSliderChange, value: v, min: min, max: max, step: step, currency: currency, hasStepsLabel: hasStepsLabel, helperErrorText: helperErrorText, hasStepsMarkers: hasStepsMarkers, testId: `${testId}.slider` }, props))))),
            error && helperErrorText && (react_1.default.createElement(range_input_styles_1.StyledHelperErrorText, { error: error, "data-testid": `${testId}.error` }, helperErrorText)),
            isRangeSliderVisible && !error && !helperErrorText && (react_1.default.createElement(range_input_styles_1.StyledValueBox, null,
                react_1.default.createElement(range_input_styles_1.StyledLeftValue, { isError: error }, priceFormatter(String(min))),
                react_1.default.createElement(range_input_styles_1.StyledRightValue, { isError: error },
                    priceFormatter(String(max)),
                    ' '))),
            description)),
        extraContent));
};
exports.BaseRangeInput = BaseRangeInput;
